import React from 'react';
import { Link } from 'react-router-dom';
import './block2.css';

function Block2() {
    return (
        <div className="block block_2">
            <div className="container">
                <h1>2017年度酒吧VIP方案</h1><br />
                <h3>活動期間:<span> 2017/09/01 ~ 2018/08/31</span></h3>
                <h3>參加資格: 所有遊戲酒吧玩家</h3>
                <h3>活動辦法: </h3>
                <ul style={{ paddingLeft: '0px' }}>
                    <li>玩家於遊戲酒吧平台累積儲值成功金額累積達到各卡別門檻，即為該卡別VIP。(詳細規範請參考VIP資格取得方式。 )</li>
                    <li><span>VIP資格有效期間為：VIP升級當月 至 2018/08/31止</span>，最多可享12個月，<span>有效期間結束後將不再享有VIP回饋。</span>(詳細規範請參考VIP回饋方案)</li>
                </ul>
                <h3 className="top">VIP資格取得方式：</h3>
                <table className="vipdetail">
                    <tbody>
                        <tr>
                            <td>卡別</td>
                            <td><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/greencard.png" width="35" />綠卡</td>
                            <td><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/silvercard.png" width="35" />銀卡</td>
                            <td><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/goldcard.png" width="35" />金卡</td>
                            <td><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/blackcard.png" width="35" />黑卡</td>
                        </tr>
                        <tr>
                            <td>累積儲值金額</td>
                            <td>金額不限<br />完善個人資料<br />即可升級</td>
                            <td>30,000元</td>
                            <td>250,000元</td>
                            <td>500,000元</td>
                        </tr>
                        <tr>
                            <td>生效時間</td>
                            <td>立即生效</td>
                            <td>立即生效</td>
                            <td>立即生效</td>
                            <td>立即生效</td>
                        </tr>
                        <tr>
                            <td>有效期間</td>
                            <td colSpan="4">2017/09/01 至 2018/08/31 止</td>
                        </tr>
                        <tr>
                            <td colSpan="5">
                                <ol style={{ paddingLeft: '10px' }}>
                                    備註:
                                    <li>以上幣別為新台幣。</li>
                                    <li>歷史累積儲值金額：於遊戲酒吧平台完成付款之訂單總金額。以成功完成交易的訂單金額為準，未完成交易、儲值後退款或否認交易等情況不納入計算。若取得VIP資格後發生退款或否認交易等情況致影響VIP資格認定，主辦單位有權取消VIP資格及對應之回饋權益。</li>
                                    <li>VIP資格有效期間最長以本活動期間為限。活動期間內若連續達到升級資格，以等級較高的卡別為準；升級後等級較低的卡別自動失效。例, 若綠卡玩家累積儲值25萬, 同時符合銀卡與金卡資格，將以金卡資格為準。<span>有效期間結束後將不再享有VIP回饋。</span></li>
                                    <li>範例A: A玩家於2017/10/15累積儲值金額達3萬元，2017/10/15升級銀卡VIP，有效期間為2016/10/15 ~ 2017/08/31。 若該玩家繼續儲值至2018/02/15累積儲值金額達25萬元，2018/02/15升級金卡VIP，有效期間為2018/02/15 ~ 2017/08/31，原銀卡資格自動失效。</li>
                                    <li>範例B: B玩家於2018/8/15累積儲值金額達3萬元，2018/8/15升級銀卡VIP，有效期間為2018/8/15 ~ 2017/08/31。</li>
                                </ol>
                            </td>
                        </tr>
                    </tbody>
                </table>


                <ul className="mobile_table clearfix">
                    <li className="card_title cd_green">
                        <img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/greencard.png" width="35" />綠卡
                    </li>
                    <li>
                        <h5 className="th">累積儲值金額</h5>
                        <h5>金額不限，完善個人資料即可升級</h5>
                    </li>
                    <li>
                        <h5 className="th">生效時間</h5>
                        <h5>立即生效</h5>
                    </li>
                    <li>
                        <h5 className="th">有效期間</h5>
                        <h5>2017/09/01 至 2018/08/31 止</h5>
                    </li>
                </ul>

                <ul className="mobile_table clearfix">
                    <li className="card_title cd_silver">
                        <img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/silvercard.png" width="35" />銀卡
                    </li>
                    <li>
                        <h5 className="th">累積儲值金額</h5>
                        <h5>30,000元</h5>
                    </li>
                    <li>
                        <h5 className="th">生效時間</h5>
                        <h5>立即生效</h5>
                    </li>
                    <li>
                        <h5 className="th">有效期間</h5>
                        <h5>2017/09/01 至 2018/08/31 止</h5>
                    </li>
                </ul>

                <ul className="mobile_table clearfix">
                    <li className="card_title cd_gold"><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/goldcard.png" width="35" />金卡</li>
                    <li>
                        <h5 className="th">累積儲值金額</h5>
                        <h5>250,000元</h5>
                    </li>
                    <li>
                        <h5 className="th">生效時間</h5>
                        <h5>立即生效</h5>
                    </li>
                    <li>
                        <h5 className="th">有效期間</h5>
                        <h5>2017/09/01 至 2018/08/31 止</h5>
                    </li>
                </ul>

                <ul className="mobile_table clearfix">
                    <li className="card_title cd_black"><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/blackcard.png" width="35" />黑卡</li>
                    <li>
                        <h5 className="th">累積儲值金額</h5>
                        <h5>500,000元</h5>
                    </li>
                    <li>
                        <h5 className="th">生效時間</h5>
                        <h5>立即生效</h5>
                    </li>
                    <li>
                        <h5 className="th">有效期間</h5>
                        <h5>2017/09/01 至 2018/08/31 止</h5>
                    </li>
                </ul>
                <ol className="mobile_table note">
                    <h4>備註:</h4>
                    <li>以上幣別為新台幣。</li>
                    <li>歷史累積儲值金額：於遊戲酒吧平台完成付款之訂單總金額。以成功完成交易的訂單金額為準，未完成交易、儲值後退款或否認交易等情況不納入計算。若取得VIP資格後發生退款或否認交易等情況致影響VIP資格認定，主辦單位有權取消VIP資格及對應之回饋權益。</li>
                    <li>VIP資格有效期間最長以本活動期間為限。活動期間內若連續達到升級資格，以等級較高的卡別為準；升級後等級較低的卡別自動失效。例, 若綠卡玩家累積儲值25萬, 同時符合銀卡與金卡資格，將以金卡資格為準。<span>有效期間結束後將不再享有VIP回饋。</span></li>
                    <li>範例A: A玩家於2017/10/15累積儲值金額達3萬元，2017/10/15升級銀卡VIP，有效期間為2016/10/15 ~ 2017/08/31。 若該玩家繼續儲值至2018/02/15累積儲值金額達25萬元，2018/02/15升級金卡VIP，有效期間為2018/02/15 ~ 2017/08/31，原銀卡資格自動失效。</li>
                    <li>範例B: B玩家於2018/8/15累積儲值金額達3萬元，2018/8/15升級銀卡VIP，有效期間為2018/8/15 ~ 2017/08/31。</li>
                </ol>

                <h3 className="top">VIP回饋方案：</h3>

                <table className="vipdetail">
                    <tbody>
                        <tr>
                            <td>卡別</td>
                            <td><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/greencard.png" width="35" />綠卡</td>
                            <td><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/silvercard.png" width="35" />銀卡</td>
                            <td><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/goldcard.png" width="35" />金卡</td>
                            <td><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/blackcard.png" width="35" />黑卡</td>
                        </tr>
                        <tr>
                            <td>點數加碼特權</td>
                            <td>無</td>
                            <td>指定管道儲值返利<span>8%</span>, 儲值成功即可領取。</td>
                            <td>指定管道儲值返利<span>10%</span>, 儲值成功即可領取。</td>
                            <td>指定管道儲值返利<span>12%</span>, 儲值成功即可領取。</td>
                        </tr>
                        <tr>
                            <td colSpan="5">
                                <ol style={{ paddingLeft: '10px' }}>
                                    備註:
                                    <li>儲值返利說明:
                                        <span>透過
                                            <Link className="link_shop" style={{ color: '#00a0e9' }} to="/shop">VIP指定管道</Link>
                                            儲值即可享有點數返利，儲值完成直接發放至平台帳戶，
                                            返利點數需在次月底前兌換入遊戲中，若未於使用期限前兌換至遊戲致點數過期失效，
                                            無法延展或補發。
                                        </span>
                                    </li>
                                </ol>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <ul className="mobile_table clearfix">
                    <li className="card_title cd_green"><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/greencard.png" width="35" />綠卡</li>
                    <li>
                        <h5 className="th">指定管道儲值返利</h5>
                        <h5>儲值返利<span>無</span></h5>
                    </li>
                </ul>

                <ul className="mobile_table clearfix">
                    <li className="card_title cd_silver"><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/silvercard.png" width="35" />銀卡</li>
                    <li>
                        <h5 className="th">指定管道儲值返利</h5>
                        <h5>儲值返利<span>8%</span></h5>
                    </li>
                </ul>

                <ul className="mobile_table clearfix">
                    <li className="card_title cd_gold"><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/goldcard.png" width="35" />金卡</li>
                    <li>
                        <h5 className="th">指定管道儲值返利</h5>
                        <h5>儲值返利<span>10%</span></h5>
                    </li>
                </ul>

                <ul className="mobile_table clearfix">
                    <li className="card_title cd_black"><img alt="" src="https://storage.googleapis.com/tech-cdn.pubgame.tw/vip2017/images/blackcard.png" width="35" />黑卡</li>
                    <li>
                        <h5 className="th">指定管道儲值返利</h5>
                        <h5>儲值返利<span>12%</span></h5>
                    </li>
                </ul>
                <ol className="mobile_table note">
                    <h4>備註:</h4>
                    <li>儲值返利說明:
                        <span>透過
                            <Link to="/shop" className="link_shop" style={{ color: '#00a0e9' }}>VIP指定管道</Link>
                            儲值即可享有點數返利，儲值完成直接發放至平台帳戶，
                            返利點數需在次月底前兌換入遊戲中，若未於使用期限前兌換至遊戲致點數過期失效，
                            無法延展或補發。
                        </span>
                    </li>
                </ol>
            </div>
        </div>
    );
}

export default Block2;


// WEBPACK FOOTER //
// ./src/containers/home/block2.jsx